import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { brandSecondary, mention, spanishBlue } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		width: 350,
	},
	dragContainer: {
		marginBottom: THEME.spacing.md,
		alignItems: 'center',
		background: mention,
		border: `2px dashed ${THEME.colors.primary.main}`,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0px 0px 6px rgba(139,139,139, 0.1)',
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		padding: THEME.spacing.md,
		textAlign: 'center',
		transition: 'all 0.2s ease-in-out',
		':hover': {
			border: `2px dashed ${brandSecondary}`,
			background: '#dceef7',
		},
	},
	dragContainerActive: {
		border: `4px dashed ${brandSecondary}`,
		background: '#dceef7',
	},
	dragContainerDisabled: {
		opacity: 0.6,
		cursor: 'not-allowed',
		pointerEvents: 'none',
	},
	dragInfo: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 12,
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 12,
		padding: THEME.spacing.md,
	},
	spinner: {
		width: 32,
		height: 32,
		border: `3px solid ${THEME.colors.border.main}`,
		borderTop: `3px solid ${THEME.colors.primary.main}`,
		borderRadius: '50%',
		animationName: {
			'0%': {
				transform: 'rotate(0deg)',
			},
			'100%': {
				transform: 'rotate(360deg)',
			},
		},
		animationDuration: '1s',
		animationIterationCount: 'infinite',
		animationTimingFunction: 'linear',
	},
	loadingText: {
		color: spanishBlue,
		fontSize: 14,
		fontWeight: 500,
	},
	dragText: {
		color: spanishBlue,
		fontSize: 14,
		fontWeight: 500,
		marginTop: 8,
	},
	dragSubtext: {
		color: brandSecondary,
		fontSize: 12,
	},
	dragFooter: {
		color: brandSecondary,
		fontSize: 12,
		marginTop: 4,
	},
	fileList: {
		marginBottom: THEME.spacing.md,
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	fileItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		transition: 'all 0.2s ease-in-out',
	},
	fileName: {
		fontSize: 14,
		color: '#333',
		flex: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		textAlign: 'left',
	},
	removeButton: {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		padding: THEME.spacing.xs,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'all 0.2s ease-in-out',
		':hover': {
			transform: 'scale(1.1)',
		},
	},
	removeIcon: {
		width: 16,
		height: 16,
		color: THEME.colors.border.main,
	},
	hidden: {
		display: 'none',
	},
});
